export const SYSTEM_PROTOCOL_URLS = {
  USER_AGREEMENT: 'user_agreement',
  PRIVACY_POLICY: 'privacy_policy',
  PURCHASE_DISCLAIMER: 'tb_disclaimer',
  PROHIBITED_ITEMS: 'disabled_transport_detail',
  TRANSSHIPMENT_ORDER_AGREEMENT: 'TransshipmentOrderAgreement',
  CONSOLIDATION_DISCLAIMER: 'consolidation_disclaimer',
  PAYMENT_PURCHASE_NOTICE: 'payment_purchase_notice',
  MANUAL_PURCHASE_AGREEMENT: 'manual_purchase_agreement',
  PACKAGE_FORECAST_RULES: 'package_forecast_rules',
  VALUE_ADDED_SERVICE_AGREEMENT: 'value_added_service_agreement',
  PRODUCT_SERVICE_DISCLAIMER: 'product_service_disclaimer',
};

const legacyAliases = {
  tbDisclaimer: SYSTEM_PROTOCOL_URLS.PURCHASE_DISCLAIMER,
  disableTransportDetail: SYSTEM_PROTOCOL_URLS.PROHIBITED_ITEMS,
};
export function resolveSystemProtocolUrl(value) {
  const input = String(value || '').trim();
  if (Object.values(SYSTEM_PROTOCOL_URLS).includes(input)) return input;
  if (legacyAliases[input]) return legacyAliases[input];
  if (/\/(?:[^/]+_)?user_service\.html(?:[?#]|$)/i.test(input)) return SYSTEM_PROTOCOL_URLS.USER_AGREEMENT;
  if (/\/(?:[^/]+_)?privacy\.html(?:[?#]|$)/i.test(input)) return SYSTEM_PROTOCOL_URLS.PRIVACY_POLICY;
  if (/\/WaitPayRule(?:[?#]|$)/i.test(input)) return SYSTEM_PROTOCOL_URLS.PAYMENT_PURCHASE_NOTICE;
  const match = input.match(/[?&]url=([^&#]+)/);
  if (match) {
    try { return resolveSystemProtocolUrl(decodeURIComponent(match[1])); } catch { return undefined; }
  }
  return undefined;
}

export function systemProtocolArticlePath(url) {
  return '/article/detail?url=' + encodeURIComponent(url);
}
